/** Read once, before React, telemetry, or third-party scripts can observe callback parameters. */
const url = new URL(window.location.href);
export let magicLinkToken: string | null =
  url.pathname === '/auth/callback' ? new URLSearchParams(url.hash.slice(1)).get('token') : null;
export function takeMagicLinkToken(): string | null {
  const token = magicLinkToken;
  magicLinkToken = null;
  return token;
}
if (url.pathname === '/auth/callback' || url.pathname.startsWith('/checkout/')) {
  const lang = new URLSearchParams(url.hash.slice(1)).get('lang');
  if (lang && ['ro', 'en', 'hu'].includes(lang)) url.searchParams.set('lang', lang);
  url.hash = '';
  for (const key of ['token', 'payment_intent', 'payment_intent_client_secret', 'redirect_status'])
    url.searchParams.delete(key);
  window.history.replaceState(window.history.state, '', url.pathname + url.search);
}
